import { render } from "./SlideText.vue?vue&type=template&id=7abbd896&ts=true"
import script from "./SlideText.vue?vue&type=script&lang=ts"
export * from "./SlideText.vue?vue&type=script&lang=ts"

import "./SlideText.vue?vue&type=style&index=0&id=7abbd896&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__